/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { AFPTable } from '@gsa/afp-component-library';
import { emDashUnicode } from '@/utilities/constants';
import { GET_SIN_CLASSIFICATION } from '../../queries';
import { toVehicleClassifications } from '../apis/sin-classification-helpers';
import './styles/solicitation-modal.scss';

const InactiveSITable = ({ inactiveSins, contractYear }) => {
  const { data } = useQuery(GET_SIN_CLASSIFICATION, {
    variables: { year: [contractYear], isActive: [1] },
  });

  const columns = [
    {
      Header: 'Standard Item',
      accessor: 'standardItem',
    },
    {
      Header: 'Vehicle Type',
      accessor: 'vehicleType',
    },
  ];

  const tableData = useMemo(() => {
    const vehicleClassifications = toVehicleClassifications(
      data?.getSinClassification || [],
    );

    const getVehicleTypeFromCode = (code) => {
      const vehicleTypes = vehicleClassifications.filter(
        (item) => item.uniqueKey === 'vehicleType' && item.value === code,
      );
      if (vehicleTypes.length > 0) {
        return vehicleTypes[0].label.split('-')[1];
      }
      return emDashUnicode;
    };

    return inactiveSins.map(({ standardItem }) => ({
      standardItem: `${standardItem.standardItemNumber} - ${standardItem.title}`,
      vehicleType: getVehicleTypeFromCode(standardItem.vehicleType),
    }));
  }, [inactiveSins, data?.getSinClassification]);

  return (
    <div className="overflow-y">
      <AFPTable columns={columns} data={tableData} />
    </div>
  );
};

export default InactiveSITable;
